<template>
  <modal-padrao
    id="modal-entregavel"
    ref="modal"
    titulo-modal="ENTREGAVEL"
    @ok="salvar"
    @cancelar="fecharModal"
  >
    <div>
      <div v-for="(entregavel, i) in form" :key="i" class="row">
        <input-select
          class="col-12 col-md-4"
          label="Tipo"
          v-model="entregavel.tipo"
          @input="preencherCamposDeTipo(entregavel)"
          :options="opcoes.tipo"
          ref="tipo"
          required
        >
          <template #prepend>
            <b-button
              v-if="form.length > 1"
              @click="removerLinha(entregavel)"
              class="mr-2"
              variant="flat-danger"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </template>
        </input-select>
        <input-select
          class="col-12 col-md-3"
          label="Produto"
          v-model="entregavel.subtipo"
          :options="subtipoCalculado(entregavel.tipo)"
          ref="tipo"
          required
        />
        <input-text
          class="col-12 col-md-1"
          label="Sequencial"
          v-model="entregavel.sequencial"
          ref="sequencial"
          required
        />
        <input-select
          class="col-12 col-md-4"
          label="Previsão de entrega"
          v-model="entregavel.prazo"
          :options="mesesDepesas"
          ref="mes"
          required
        >
          <template #append>
            <b-button
              v-if="!entregavel.id"
              @click="adicionarLinha"
              class="ml-2"
              variant="flat-info"
            >
              <i class="fas fa-plus"></i>
            </b-button>
          </template>
        </input-select>
      </div>
    </div>
  </modal-padrao>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText";
import PropostaService from "@/common/services/proposta/proposta.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import helpers from "@/common/utils/helpers";
import cloneDeep from "lodash.clonedeep";
export default {
  components: {
    InputSelect,
    InputText,
  },
  data: function () {
    return {
      opcoes: {
        tipo: helpers.TipoEntregaveis,
        subtipo: helpers.SubTipoEntregaveis,
      },
      quantidades: [],
      form: [],

      duracao: 0,
      propostaId: "",
      valores: [],
    };
  },
  methods: {
    abrirModal: function (
      duracao,
      propostaId,
      valores,
      form = [
        {
          propostaId: null,
          tipo: null,
          subtipo: null,
          prazo: null,
          valor: 1,
        },
      ]
    ) {
      this.form = form;

      this.valores = cloneDeep(valores);
      this.duracao = duracao;
      this.propostaId = propostaId;

      this.$refs.modal.abrirModal();
    },
    fecharModal: function () {
      this.$emit("buscar");
      this.$refs.modal.fecharModal();
    },

    salvar: function () {
      this.confirmar("Aviso", "Deseja salvar os entregáveis?").then((confirmado) => {
        if (!confirmado) return;

        if (this.validarFormulario() == false) return;

        this.$store.dispatch(START_LOADING);

        let form = cloneDeep(this.form);

        form.forEach((item, i) => {
          item.indice = i;
          item.propostaId = this.propostaId;
          item.propostaEmpresaExecutoraId = this.propostaId;

          PropostaService.salvarEntregavel(item)
            .then(() => {
              this.toastSucesso(`Entregável salvo com sucesso!`);

              this.form.splice(
                this.form.indexOf(this.form.find((el) => el.indice == i)),
                1
              );
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.toastErro(`Erro ao salvar entregável: ${err.data.errors}`);
              } else {
                this.toastErro(`Erro ao salvar entregável`);
              }
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        });
      });
    },

    preencherCamposDeTipo(entregavel) {
      this.mudarTipo(entregavel);
      this.setarSequencial(entregavel);
    },
    mudarTipo: function (entregavel) {
      let subtipos = this.subtipoCalculado(entregavel.tipo);
      if (subtipos.length == 1) {
        entregavel.subtipo = subtipos[0].value;
      }
    },
    setarSequencial: function (entregavel) {
      let qtd = cloneDeep(this.quantidades);
      if (entregavel.tipo) {
        qtd.find((el2) => el2.subtipo == entregavel.tipo).quantidade++;
        entregavel.sequencial = qtd.find(
          (el2) => el2.subtipo == entregavel.tipo
        ).quantidade;
      }
    },
    subtipoCalculado: function (tipo) {
      let _tipo = this.opcoes.tipo.find((el) => el.value == tipo);
      let subtipo = _tipo ? _tipo.subtipo : "";
      return this.opcoes.subtipo.filter((el) => {
        return el.value == subtipo;
      });
    },
    adicionarLinha: function () {
      let element = {
        propostaId: null,
        tipo: null,
        subtipo: null,
        prazo: null,
        sequencial: null,
        valor: 1,
      };

      this.form.push(element);
    },
    removerLinha: function (linha) {
      this.form.splice(this.form.indexOf(linha), 1);
    },
  },
  computed: {
    mesesDepesas() {
      return helpers.criarArrayMes(`2022-01-01`, this.duracao, true);
    },
  },
  watch: {
    form: {
      handler() {
        if (this.form.length == 0) {
          this.fecharModal();
        }
      },
      deep: true,
    },
    valores: {
      handler: function (valores) {
        helpers.TipoEntregaveis.forEach((element) => {
          let quantidade = valores
            .filter((aux) => aux.tipo == element.value)
            .sort((a, b) => a.sequencial - b.sequencial)
            .slice(-1);

          if (quantidade.length == 0) {
            this.quantidades.push({
              subtipo: element.value,
              quantidade: 0,
            });
          } else {
            this.quantidades.push({
              subtipo: element.value,
              quantidade: quantidade[0].sequencial,
            });
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang=""></style>
